export const URLS = {
  login: '/users/login',
  usersPassword: '/users/password',
  user: '/user',
  getAccessList: '/users/getAccessList',
  changePassword: '/users/change_password',
  entity: '/entity',
  producttypes: '/producttypes',
  clientFacingProducts: '/clientFacingProducts',
  clientFacingProductsValidate: '/clientFacingProducts/validate',
  assettypes: '/assettypes',
  clients: '/clients',
  client: '/client',
  buyers: '/buyers',
  buyer: '/buyer',
  sellers: '/sellers',
  seller: '/seller',
  address: '/address',
  coordinateFromAddress: '/coordinateFromAddress',
  partners: '/partners',
  order: '/order',
  recordingJuisdictions: '/recordingJurisdictions',
  recordingJurisdiction: '/recordingJurisdiction',
  documentType: '/document_type',
  orderSearchSection: '/search',
  orderInterestTypes: '/orderInterestTypes',
  toggleBookmarkStatus: '/toggleBookmarkStatus',
  intereststypes: '/intereststypes',
  executetypes: '/executetypes',
  chainoftitletypes: '/chainoftitletypes',
  lienstypes: '/lienstypes',
  requirementstypes: '/requirementstypes',
  exceptiontypes: '/exceptiontypes',
  jurisdictionstypes: '/jurisdictionstypes',
  saveTypeExam: '/saveTypeExam',
  updateTypeExam: '/updateTypeExam',
  typeExam: '/typeExam',
  surveyReview: '/surveyReview',
  saveSurveyReview: '/saveSurveyReview',
  generateSurveyReviewDocument: '/generateSurveyReviewDocument',
  surveyReviewNewDocument: '/surveyReview/newDocument',
  surveyReviewRetry: '/surveyReviewRetry',
  taskTitles: '/taskTitles',
  subTaskTitles: '/subTaskTitles',
  tasksList: 'tasksList',
  tasks: '/tasks',
  task: '/task',
  teamsName: '/teamsName',
  members: '/members',
  taskMembers: '/taskMembers',
  comments: '/comments',
  roles: '/roles',
  peoples: '/peoples',
  people: '/people',
  team: '/team',
  invitation: '/invitation',
  generateDocument: '/generate_document',
  get_document: '/get_document',
  update_document: '/update_document',
  searchTask: '/searchTask',
  activityComments: '/activityComments',
  mergePdf: '/mergePdf',
  documentsTypes: '/documentsTypes',
  documents: '/documents',
  uploadOrderDocuments: '/uploadOrderDocuments',
  documentsSortList: '/documentsSortList',
  documentsFilterList: '/documentsFilterList',
  attachmentTypeCategories: '/attachmentTypeCategories',
  attachmentTypeCategory: '/attachmentTypeCategory',
  documentTypeCategories: '/documentTypeCategories',
  documentTypeCategory: '/documentTypeCategory',
  updateDocument: '/updateDocument',
  deleteDocument: '/deleteDocument',
  deliverables: '/deliverables',
  milestone: '/milestone',
  getTaskStatistics: '/getTaskStatistics',
  taskPreviewSortList: '/taskPreviewSortList',
  taskPreviewFilterList: '/taskPreviewFilterList',
  taskPreviewAssigneeList: '/taskPreviewAssigneeList',
  getTaskCompleted: '/getTaskCompleted',
  dashboardTasks: '/dashboardTasks',
  getProjectNamesList: '/getProjectNamesList',
  getProjectNamesStats: '/getProjectNamesStats',
  partnerProfile: '/partnerProfile',
  partnerProfiles: '/partnerProfiles',
  partnerProfileTypes: '/partnerProfileTypes',
  profileAttachmentTypes: '/profileAttachmentTypes',
  partnerContact: '/partnerContact',
  partnerContacts: '/partnerContacts',
  partnerCommunications: '/partnerCommunications',
  purchaseOrderOptions: '/purchaseOrderOptions',
  emailSubjectFormat: '/emailSubjectFormat',
  clientDetail: '/clientDetail',
  partnerComments: 'partnerComments',
  productFee: '/productFee',
  orderEnable: '/orderEnable',
  orderCancel: '/orderCancel',
  orderPreviewSortList: '/orderPreviewSortList',
  orderPreviewFilterList: '/orderPreviewFilterList',
  clientOrderNumbers: '/clientOrderNumbers',
  orderDashboard: '/orderDashboard',
  getVisits: '/getVisits',
  saveVisit: '/saveVisit',
  openLienType: '/openLienType',
  miscsType: '/miscsType',
  leaseType: '/leaseType',
  openMortgageType: '/openMortgageType',
  toogleBookmarkStatusOpenLien: '/toogleBookmarkStatusOpenLien',
  toogleBookmarkStatusMiscs: '/toogleBookmarkStatusMiscs',
  toogleBookmarkStatusLease: '/toogleBookmarkStatusLease',
  toogleBookmarkStatusOpenMortgage: '/toogleBookmarkStatusOpenMortgage',
  getZipCodeAutofill: '/getZipCodeAutofill',
  autofillAddress: '/autofillAddress',
  orderDetailsTabList: '/orderDetailsTabList',
  getClientMap: '/getClientMap',
  getPreviewDeliverables: '/getPreviewDeliverables',
  siteNames: '/siteNames',
  storage: '/storage',
  getAddressFromCoords: '/getAddressFromCoords',
  partnerContactResendInvite: '/partnerContactResendInvite',
  partnerContactToggleStatus: '/partnerContactToggleStatus',
  states: '/states',
  counties: '/counties',
  countiesList: '/countiesList',
  towns: '/towns',
  clientMapSearch: '/clientMapSearch',
  clientMapSearchList: '/clientMapSearchList',
  bookmarkSearch: '/bookmarkSearch',
  bookmarkMap: '/bookmarkMap',
  bookmarkMapElement: '/bookmarkMapElement',
  mapWindowInfo: '/mapWindowInfo',
  assetsSiteListCsv: '/assets/Site List.csv',
  assetsBulkCalcCsv: '/assets/Bulk Quote Template.csv',
  project: '/project',
  projectEnable: '/projectEnable',
  getMilestoneStatuses: '/getMilestoneStatuses',
  projectActivity: '/projectActivity',
  projectDocuments: '/projectDocuments',
  projectOrders: '/projectOrders',
  projectOrdersFilterList: '/projectOrdersFilterList',
  projectOrdersSortList: '/projectOrdersSortList',
  addProjectOrders: '/addProjectOrders',
  projectAllocate: '/projectAllocate',
  projectDeallocate: '/projectDeallocate',
  projectPreviewSortList: '/projectPreviewSortList',
  projectPreviewFilterList: '/projectPreviewFilterList',
  projectDashboard: '/projectDashboard',
  getAddressFromId: '/getAddressFromId',
  bookmarkBulkUpload: '/bookmarkBulkUpload',
  bookmarkSites: '/bookmarkSites',
  updateSiteCoords: '/updateSiteCoords',
  bookmarkSitesCount: '/bookmarkSitesCount',
  mapPinInfo: '/mapPinInfo',
  signature: '/signature',
  signatureList: '/signatureList',
  signatureDefaults: '/signatureDefaults',
  signatureFilled: '/signatureFilled',
  userTeams: '/userTeams',
  mailboxMessages: '/mailboxMessages',
  mailboxMessage: '/mailboxMessage',
  jobTitles: '/jobTitles',
  searchMailAddress: '/searchMailAddress',
  composeEmail: '/composeEmail',
  mailboxMessageForward: '/mailboxMessageForward',
  forwardEmail: '/forwardEmail',
  replyEmail: '/replyEmail',
  replyRecipients: '/replyRecipients',
  getSitePropertyDetails: '/getSitePropertyDetails',
  placeOrderFromEmail: '/placeOrderFromEmail',
  getChannelAccessToken: '/getChannelAccessToken',
  partnerProfilePreviewSortList: '/partnerProfilePreviewSortList',
  partnerProfilePreviewFilterList: '/partnerProfilePreviewFilterList',
  profileDashboard: '/profileDashboard',
  orderList: '/orderList',
  archiveEmailComment: '/archiveEmailComment',
  emailMetadata: '/emailMetadata',
  activityEmailShare: '/activityEmailShare',
  profileProducts: '/profileProducts',
  emailComment: '/emailComment',
  markRead: '/markRead',
  defaultSubjectLine: '/defaultSubjectLine',
  productFeeAll: '/productFeeAll',
  abstractorProfile: '/abstractorProfile',
  partnerPriorities: '/partnerPriorities',
  partnerBusinessTypes: '/partnerBusinessTypes',
  allPartnersWithTypes: '/allPartnersWithTypes',
  advanceProductFee: '/advanceProductFee',
  advanceProductFeeAll: '/advanceProductFeeAll',
  rate: '/rate',
  ratePdf: '/ratePdf',
  rateExcel: '/rateExcel',
  rates: '/rates',
  partnerProfileContacts: '/partnerProfileContacts',
  ratesBulkUpload: '/ratesBulkUpload',
  ratesBulkCreate: '/ratesBulkCreate',
  ratesBulk: '/ratesBulk',
  ratesPdf: '/ratesPdf',
  ratesExcel: '/ratesExcel',
  getOrderAbstractors: '/getOrderAbstractors',
  assigneesOrderUniqueIds: '/assigneesOrderUniqueIds',
  t00Profile: '/t00Profile',
  workshareProfile: '/workshareProfile',
  orderDashboardMap: '/orderDashboardMap',
  getOrderDashboardStats: '/getOrderDashboardStats',
  clientNotifications: '/clientNotifications',
  clientNotificationUnreadCount: '/clientNotificationUnreadCount',
  markClientNotificationRead: '/markClientNotificationRead',
  markAllClientNotificationsRead: '/markAllClientNotificationsRead',
  orderDashboardDateRangeFilters: '/orderDashboardDateRangeFilters',
  orderDashboardMilestoneStatusFilters: '/orderDashboardMilestoneStatusFilters',
  userPreferences: '/userPreferences',
  impersonationUsers: '/impersonationUsers',
  impersonation: '/impersonation'
};
